<template>
<div class="chapter">
<div class="inner_page">
<p class="front-cover" id="page_1"><img alt="Front Cover of Pistaco" src="images/9780879466497_cover.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 000_Cover.vue?72e272c8